import React from 'react';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

export function DocumentTransportation(props) {
    let baseUrl = window.location.origin + "/";
    return <>
        <h4 style={{ marginLeft: "40px" }} className="phraseValueHeader">{props.localizations.Transportation}</h4>
        <Grid
            className="sphera-grid"
            style={{
                height: '330px',
                width: '95%',
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "10px",
                maxHeight: '380px'
            }}
            data={props.transportationDataResult}
            {...props.transportationDataState}
            onDataStateChange={props.transportationStateChange}
            sortable={true}
            reorderable={true}
            resizable={true}
            scrollable="scrollable"
            pageable={{
                buttonCount: 4,
                pageSizes: [25, 50, 100]
            }}
        >
            <Column
                field="name"
                minResizableWidth={100}
                title={props.localizations.ShippingName}
                filter="text"
            />
            <Column
                field="unNumber"
                minResizableWidth={100}
                title={props.localizations.UNNumber}
                filter="text"
            />
            <Column
                field="classes"
                minResizableWidth={100}
                title={props.localizations.Classes}
                filter="text"
            />
            <Column
                field="packing"
                minResizableWidth={100}
                title={props.localizations.Packing}
                filter="text"
            />
            <Column
                field="agency"
                minResizableWidth={100}
                title={props.localizations.Agency}
                filter="text"
            />
            <Column
                field="placards"
                minResizableWidth={100}
                title={props.localizations.Placards}
                filter="text"
                cell={(props2) =>
                    <td className="k-table-td" style={{ textAlign: "center", whiteSpace: "normal" }}>
                        {props2.dataItem.hazards.map((x, index) => x.pictogramSourceId ? <React.Fragment key={"picto" + index}><img src={baseUrl + "pictograms/" + x.pictogramSourceId + ".png"} alt={x.pictogramSourceId} height="60" key={"picto" + index} /></React.Fragment> : <span key={"picto" + index}>{x.class}</span>)}
                    </td>
                }
            />
            <Column
                field="environmental"
                minResizableWidth={100}
                title={props.localizations.Environmental}
                filter="text"
                cell={(props2) => props2.dataItem.environmental ? <td className="k-table-td" style={{ textAlign: "center" }}> <i class="icon-ui-general-check" /></td> : <td className="k-table-td" style={{ textAlign: "center" }}></td>}
            />
        </Grid>
    </>;
}